// extracted by mini-css-extract-plugin
export default {"information":"AdministrationInfoWarning_information__oGpKv","hintIcon":"AdministrationInfoWarning_hintIcon__iBwpN","tableText":"AdministrationInfoWarning_tableText__sqlgx"};